import React, { FC, useEffect, useRef, useState } from 'react';
import { TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface Props {
  refresh?: number;
  onChange: (placeId: string) => void;
}

const PlaceIDFinder: FC<Props> = ({ refresh, onChange }) => {
  const { t } = useTranslation();

  const inputRef = useRef<HTMLInputElement>(null);
  const [placeId, setPlaceId] = useState<string>('');

  const loadScript = (url: string) => {
    return new Promise<void>((resolve, reject) => {
      const existingScript = document.querySelector(`script[src="${url}"]`);
      if (existingScript) {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.src = url;
      script.async = true;
      script.defer = true;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error(url + ' failed to load'));
      document.head.appendChild(script);
    });
  };

  useEffect(() => {
    setPlaceId('');
    if (inputRef && inputRef.current) {
      inputRef.current.value = '';
    }
  }, [refresh]);

  useEffect(() => {
    const loadGoogleMaps = async () => {
      try {
        const apiKey = 'AIzaSyAT78sdrzHIgZ-QVu2PE2hTxS-aQbjs5u0';
        const url = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&v=weekly`;

        await loadScript(url);

        const waitForGoogle = () => {
          return new Promise<void>((resolve) => {
            const checkGoogle = () => {
              if (window.google && window.google.maps && window.google.maps.places) {
                resolve();
              } else {
                setTimeout(checkGoogle, 100);
              }
            };
            checkGoogle();
          });
        };

        await waitForGoogle();

        if (!inputRef.current) return;

        const autocomplete = new window.google.maps.places.Autocomplete(inputRef.current, {
          fields: ['place_id'],
        });

        autocomplete.addListener('place_changed', () => {
          const place = autocomplete.getPlace();
          if (place && place.place_id) {
            setPlaceId(place.place_id);
            onChange(place.place_id);
          }
        });
      } catch (e) {
        console.error(e);
      }
    };

    loadGoogleMaps();
  }, [onChange]);

  return (
    <div>
      <TextField
        inputRef={inputRef}
        type="text"
        placeholder={t('find_company')}
        sx={{ minWidth: 400, mb: 2 }}
        autoFocus
      />
      <TextField
        value={placeId}
        type="text"
        placeholder={t('place_id')}
        sx={{ minWidth: 400 }}
        InputProps={{
          readOnly: true,
        }}
      />
    </div>
  );
};

export default PlaceIDFinder;
